import { useOptimizer } from '@/optimizer/hooks/useOptimizer';
import { Typography } from '@analytical-alley/ui';
import { useEffect, useState } from 'react';

export const OptimizerVersion = () => {
    const [version, setVersion] = useState<string>('0.0.0');
    const { getOptimizerVersion } = useOptimizer();

    useEffect(() => {
        getOptimizerVersion().then((v) => {
            setVersion(v);
        });
    }, [getOptimizerVersion]);

    return (
        <div className="flex w-full justify-start glass-tile p-6 gap-1 flex-wrap">
            <Typography className="text-sm">Powered by Opt</Typography>
            <Typography className="text-sm font-semibold">
                v{version}
            </Typography>
        </div>
    );
};
